export const CART_BASE_FEATURE = 'cartBase';
export const CART_BASE_CORE_FEATURE = 'cartBaseCore';

export const MINI_CART_FEATURE = 'miniCart';
export const ADD_TO_CART_FEATURE = 'addToCart';
export const ADD_TO_QUOTE_FEATURE = 'addToQuote';
